module.exports = __webpack_public_path__ + "media/images/oficinas/santa_lucia-6eb314b5594745f8ac883bb94e5ace71.jpg";